@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.prices
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.price.ExtendedPriceDataWithRouteDto

object GetPassengerRidePricesEndpoint : EndPoint<GetPassengerRidePricesEndpoint.Request, GetPassengerRidePricesEndpoint.Response>() {
    class Request(
        val time: DateTimeDto?,
        val pickupLat: Double,
        val pickupLng: Double,
        val destLat: Double?,
        val destLng: Double?,
        val rideId: KmmLong? = null
    )

    class Response(
        val prices: Array<ExtendedPriceDataWithRouteDto>,
    )

    class ExistingRidePromoInfo(
        val rideId: KmmLong,
        val ridePromoId: KmmLong?,
        val ridePromoDiscount: Double?
    )
}